import { cloneElement } from 'react';
import mapValues from 'lodash/mapValues';
import isFunction from 'lodash/isFunction';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import startsWith from 'lodash/startsWith';
import endsWith from 'lodash/endsWith';
import analyticsManifest from './analyticsManifest';
import UIActions from '../actionCreators/UIActions';
import { useDispatch } from "react-redux";

const matchesId = (id, pattern) => {
  return id === pattern || (endsWith(pattern, '*') && (startsWith( id, pattern.slice(0, pattern.length - 1) )));
};

export const Track = ({ children }) => {
  const dispatch = useDispatch();


  const handlers = {};
  const dataAttributes = reduce(
    children.props,
    (sum, value, key) => {
      if (startsWith(key, 'data-')) {
        const modifiedKey = key.replace('data-', '');
        sum[modifiedKey] = value;
      }
      return sum;
    },
    {}
  );
  const composedEvents = get(analyticsManifest, 'composedEvents', {});
  map(composedEvents, (value, id) => {
    if (matchesId(children.props.id, id)) {
      map(
        value,
        (analyticsData, event) => {
          handlers[event] = () => {
            if (isFunction(UIActions.enhancedTrack)) {
              dispatch(UIActions.enhancedTrack({ ...analyticsData, dataAttributes }));
            }
          };
      });
    }
  });

  const composedHandlers = !isEmpty(handlers) ?
    mapValues(
      handlers,
      (handler, event) => {
        return (e) => {
          handler(e);
          const elementEvent = children.props[event];
          if (isFunction(elementEvent)) {
            elementEvent(e);
          }
        };
      }
    ) : null;

  return cloneElement(children, composedHandlers);
};

export default Track;
